import { coerceValueRef } from "../authContext";
import type { AuthDescriptor, ValueRefInput } from "../authDescriptor";

/**
 * Emits a primitive descriptor for app-specific auth schemes whose logic lives
 * only in the proxy (Rust). Use for apps whose auth involves crypto, multi-step
 * token fetches, body/URL mutation, or other logic that can't be expressed with
 * the plain bearer/basic/header/query/oauth descriptors.
 *
 * The `handler` identifies the proxy-side handler; it typically matches the
 * connector's identifier. `params` are optional ValueRefs forwarded to the
 * handler.
 */
export function customAuth(
  handler: string,
  params: Record<string, ValueRefInput> = {}
): AuthDescriptor {
  const coerced: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(params)) coerced[k] = coerceValueRef(v);
  return { type: "primitive", name: handler, params: coerced };
}
